export enum IEnvironments {
  DEV = 'dev',
  STG = 'stg',
  PRD = 'prd',
}

export const TierOptions = [
  { label: IEnvironments.DEV, value: IEnvironments.DEV },
  { label: IEnvironments.STG, value: IEnvironments.STG },
  { label: IEnvironments.PRD, value: IEnvironments.PRD },
];

export const getNormalizedTier = (tier: string): IEnvironments => {
  const normalizedTier = TierOptions.find((option) => option.value.toLowerCase() === tier?.toLowerCase());
  return normalizedTier?.value || IEnvironments.DEV;
};

export default IEnvironments;
